/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { keyframes, css } from 'styled-components';

interface ContainerProps {
  disabled: boolean;
  loading: number;
  success: number;
  linkValidation: number;
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const LoadIcon = styled.div`
  svg {
    animation: ${rotate} 1.3s linear infinite;
    display: inline-block;
    position: inline-block;
  }
`;

export const Container = styled.button<ContainerProps>`
  width: 254px;
  border-radius: 5px;
  margin-top: 40px;
  padding: 15px 0;

  ${props =>
    props.linkValidation === 0 &&
    css`
      background: #c53030 !important;
      border-color: #c53030 !important;
      cursor: default !important;
      &:hover {
        color: #fff !important;
      }
    `}

  ${props =>
    props.success === 1 &&
    css`
      background: #00b583 !important;
      border-color: #00a376 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px !important;
      height: 40px !important;
      font-size: 18px !important;
      cursor: default !important;
      transition: background 0.5s linear, color 0.5s linear,
        border-radius 0.3s ease-in 0.1s, width 0.3s linear, padding 0s linear !important;
      color: #fff !important;
      font-size: 28px;
      border-radius: 50%;
      cursor: default !important;
      /* width: 52px !important; */

      &:hover {
        background: #00b583 !important;
        border-color: #00a376 !important;
        cursor: default !important;
        color: #fff !important;
      }
    `}

  ${props =>
    props.loading === 1 &&
    css`
      transition: background 0.5s linear, color 0.5s linear,
        border-radius 0.3s ease-in 0.1s, width 0.3s linear, padding 0s linear !important;
      background-position: left;
      color: #fff !important;
      padding: 10px 13px 4px 11px !important;
      font-size: 28px;
      /* border-radius: 50%; */
      cursor: default !important;
      /* width: 52px !important; */

      &:hover {
        color: #fff !important;
        background-position: right !important;
      }
    `}

  color: #fff;
  background: linear-gradient(to top left, #000b3a 50%, #11cdef 50%);
  background-size: 400% 250%;
  background-position: right bottom;
  /* background: #000b3a; */
  border: 1px solid #000b3a;

  transition: background 0.5s linear, color 0.5s linear,
    border-radius 0.1s linear, width 0.3s linear 0.1s, padding 0s linear;

  &:hover {
    background-position: left;
    /* background: #fff; */
    color: #000b3a;
  }
`;
